import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
// auth
import { useAuthContext } from "src/auth/hooks";
// redux
import { batch, dispatch, useSelector } from "src/redux/store";
import { clearError as clearErrorShipment } from "src/redux/slices/shipment";
import { clearError as clearErrorTransaction } from "src/redux/slices/transaction";
import { clearError, setError } from "src/redux/slices/error";
// utils
import axios from "src/utils/axios";

// ----------------------------------------------------------------------

export default function ErrorBoundary({ children }) {
    const { enqueueSnackbar } = useSnackbar();

    const { pathname } = useLocation();

    const { kicked } = useAuthContext();

    const { error } = useSelector((state) => state.error);
    //
    const { error: errorShipment } = useSelector((state) => state.shipment);
    //
    const { error: errorTransaction } = useSelector((state) => state.transaction);

    // ----------------------------------

    useEffect(() => {
        const interceptorId = axios.interceptors.response.use(
            (response) => response,
            (e) => {
                if (typeof e === "string") {
                    dispatch(setError({ msg: e }));
                } else if (typeof e === "object") {
                    dispatch(setError(e));
                }

                return Promise.reject(e);
            }
        );

        return () => {
            axios.interceptors.response.eject(interceptorId);
        };
    }, []);

    useEffect(() => {
        if (error) {
            const { code, msg } = error || {};

            if (code === "auth.jwt.invalid") {
                kicked();
            } else if (
                !pathname.includes("/signup") && !pathname.includes("/login") &&
                !( pathname.includes("/shipments/quick_rate") && code === "shipment.buy.shipment_rate_not_exist" ) &&
                code !== "payment_payment_methods_verify_fail" &&
                code !== "payment_payment_methods_verify_first_fail" &&
                msg
            ) {
                enqueueSnackbar(msg, { variant: "error", onClose: () => dispatch(clearError()) });
            }
        }

        return () => {
            dispatch(clearError());
        };
    }, [ error ]);

    useEffect(() => {
        if (errorShipment) batch(() => {
            dispatch(setError(errorShipment));
            dispatch(clearErrorShipment());
        });
    }, [ errorShipment ]);

    useEffect(() => {
        if (errorTransaction) batch(() => {
            dispatch(setError(errorTransaction));
            dispatch(clearErrorTransaction());
        });
    }, [ errorTransaction ]);

    // ----------------------------------

    return (
        <>
            { children }
        </>
    );
}

ErrorBoundary.propTypes = {
    children: PropTypes.node
};
